import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js'
import { Security, LoginCallback } from '@okta/okta-react'
import { ROUTES } from '@/constants/routes'
import { OktaAuthProvider } from '@/contexts/AuthContext'
import OktaTokenSync from './OktaTokenSync'

interface OktaSecurityWrapperProps {
  oktaAuth: OktaAuth
  children: React.ReactNode
}

/**
 * Wraps the app with Okta Security when Okta is configured.
 * Provides restoreOriginalUri using React Router navigate so we don't full-page reload after login.
 */
export default function OktaSecurityWrapper({ oktaAuth, children }: OktaSecurityWrapperProps) {
  const navigate = useNavigate()

  const restoreOriginalUri = useCallback(
    (_: OktaAuth, originalUri?: string) => {
      const path = toRelativeUrl(originalUri || ROUTES.DASHBOARD, window.location.origin)
      navigate(path || ROUTES.DASHBOARD, { replace: true })
    },
    [navigate]
  )

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      <OktaAuthProvider>
        <OktaTokenSync />
        {children}
      </OktaAuthProvider>
    </Security>
  )
}

export { LoginCallback }
